import { Box } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export interface ScrollContainerWrapperProps extends PropsWithChildren {
  height?: string;
}

const ScrollContainerWrapper: FC<ScrollContainerWrapperProps> = ({
  children,
  height = 'auto',
}) => {
  return (
    <Box sx={{ height, overflow: 'hidden' }} width="100%">
      <Box height="100%" display="flex" flexDirection="column">
        {children}
      </Box>
    </Box>
  );
};

export default ScrollContainerWrapper;
